import React from 'react';
import { SITE, STORE_COORDS } from '../constants/site';

/**
 * Google Maps embed via iframe (no API key).
 * Uses coordinates so the pin stays stable.
 */
function LocationMap({ className = '' }) {
  const { lat, lng } = STORE_COORDS;
  const src = `https://maps.google.com/maps?q=${lat},${lng}&z=16&hl=en&output=embed`;

  return (
    <div
      className={`overflow-hidden rounded-2xl border border-slate-200/80 bg-slate-100 shadow-card ${className}`}
    >
      <iframe
        title={`Google Map — ${SITE.businessName}`}
        src={src}
        className="aspect-[4/3] min-h-[260px] w-full border-0 md:aspect-video md:min-h-[320px]"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </div>
  );
}

export default LocationMap;
